import { render } from "./CustomSelectOneCity.vue?vue&type=template&id=2052dd5a"
import script from "./CustomSelectOneCity.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneCity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__